export default {
  DRAGGABLE_LIST_ITEM: 'DRAGGABLE_LIST_ITEM',
};
